// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d20eca2d","704":"dfbd8e33","998":"8b482a2c"}[chunkId] + ".chunk.js";
};